import { h, Fragment } from "preact";
import { useState, useEffect, useMemo, useCallback } from "preact/hooks";

import { ToggleButton, ToggleButtonGroup } from "@mui/lab";

//const useStyles = makeStyles((theme) => ({}));

export function ToggleYN({ name, value, setUpperState, custom }) {

	const handleChange = (event) => {
		//	setUpperState({ ...state, [name]: val });
		setUpperState({ target: { name: name, value: event.target.value } });
	}

	return (<div>
		{custom !== undefined && <ToggleButtonGroup size="small" aria-label={name} name={name} value={value} onChange={handleChange} exclusive color="primary">
			{custom.map((c) => {
				return <ToggleButton value={c[1]} aria-label={c[0]}>
					{c[0]}
				</ToggleButton>
			})}
		</ToggleButtonGroup>}
		{!custom && <ToggleButtonGroup size="small" aria-label={name} name={name} value={value} onChange={handleChange} exclusive color="primary">

			<ToggleButton value="O" aria-label="OUI">
				OUI
			</ToggleButton>
			<ToggleButton value="N" aria-label="NON">
				NON
			</ToggleButton>
			<ToggleButton value="?" aria-label="NSP">
				NE SAIS PAS
			</ToggleButton>

		</ToggleButtonGroup>
		}
	</div>)
}

// 		{ custom === undefined && <div></div> }
// 	// 	{
// 	// 	custom && (<ToggleButtonGroup size="small" aria-label={name} name={name} value={value} onChange={handleChange} exclusive color="primary">
// 	// 		{custom && custom.map((c) => {
// 	// 			return <ToggleButton value={c[1]} aria-label={c[0]}>
// 	// 				{c[0]}
// 	// 			</ToggleButton>
// 	// 		})}
// 	// 	</ToggleButtonGroup>)
// 	// }
// })
// }

